import { Component, OnInit, AfterViewInit  } from '@angular/core';
//import { AppConsts } from '@fs/abp';

//import { navigation } from '../../navigation/navigation';

//import { NewsTypeCrudServiceProxy } from '@fs/cms';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit, AfterViewInit {
	//adminUrl: string;
	//links = navigation;
	
	constructor() {}
	
	ngOnInit() {
		
	}

	ngAfterViewInit() {
      //$.getScript('./assets/js/custom.js', function () { });
	}
}
